import { getEnrollmentStatusDisplayLabel } from "@/lib/utils/enrollment-status-display";
import type { GetEnrollmentResponse } from "@/openapi/generated";

export type StudentProgressRow = {
  status: string;
  count: number;
  percentage: number;
};

export function getEnrollmentStatusLabel(status: string): string {
  return getEnrollmentStatusDisplayLabel(status) || status;
}

export function computeStudentsProgressFromEnrollments(
  enrollments: readonly GetEnrollmentResponse[],
): { items: StudentProgressRow[]; total: number } {
  const counts = new Map<string, number>();

  for (const enrollment of enrollments) {
    const status = enrollment.status ?? "Unknown";
    counts.set(status, (counts.get(status) ?? 0) + 1);
  }

  const total = enrollments.length;
  const items = Array.from(counts.entries())
    .map(([status, count]) => ({
      status,
      count,
      percentage: total > 0 ? Math.round((count / total) * 100) : 0,
    }))
    .sort((a, b) => b.count - a.count);

  return { items, total };
}
